 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"claim-accident-desc":"claim-accident-desc","claim-detail":"claim-detail","claim-entry":"claim-entry","claim-goods-type":"claim-goods-type","claim-select-bank":"claim-select-bank","claim-select-order":"claim-select-order","claim-select-responsible":"claim-select-responsible","claim-status":"claim-status","common-problem":"common-problem","coupon-login":"coupon-login","coupon-qa":"coupon-qa","login":"login","protection-rule":"protection-rule","reporting-center":"reporting-center","service-contract-rule":"service-contract-rule","vendors~accident~claim-supply~initiate-report~personal-accident":"vendors~accident~claim-supply~initiate-report~personal-accident","accident~claim-supply~initiate-report~personal-accident":"accident~claim-supply~initiate-report~personal-accident","accident~initiate-report":"accident~initiate-report","accident":"accident","initiate-report":"initiate-report","claim-supply":"claim-supply","personal-accident":"personal-accident","vendors~coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"vendors~coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select","coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select","coupon-exchange":"coupon-exchange","coupon-invalid~coupon-list~coupon-select":"coupon-invalid~coupon-list~coupon-select","coupon-invalid":"coupon-invalid","new-coupon-select":"new-coupon-select","vendors~coupon-list":"vendors~coupon-list","coupon-list":"coupon-list","vendors~coupon-select":"vendors~coupon-select","coupon-select":"coupon-select","vendors~exif-js":"vendors~exif-js"}[chunkId]||chunkId) + "." + {"claim-accident-desc":"d9ad594c","claim-detail":"916b3a32","claim-entry":"033594a2","claim-goods-type":"a8390c64","claim-select-bank":"bd62e940","claim-select-order":"fd4d8cec","claim-select-responsible":"c2b63716","claim-status":"9b56e1ef","common-problem":"11f41bf2","coupon-login":"64210ac9","coupon-qa":"f460e33e","login":"b3cdee9f","protection-rule":"f9e96ddc","reporting-center":"78df2cda","service-contract-rule":"fc327593","vendors~accident~claim-supply~initiate-report~personal-accident":"09ea6a83","accident~claim-supply~initiate-report~personal-accident":"5d70adcc","accident~initiate-report":"35c6ffed","accident":"1dfb2544","initiate-report":"07e4de99","claim-supply":"2d06689c","personal-accident":"277e8a69","vendors~coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"9558b5c7","coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"09e50190","coupon-exchange":"bfd5be0d","coupon-invalid~coupon-list~coupon-select":"dc6d3b57","coupon-invalid":"0d774022","new-coupon-select":"c754bfd6","vendors~coupon-list":"5fe17e7f","coupon-list":"4985c382","vendors~coupon-select":"2bfcfc93","coupon-select":"3adb9ff8","vendors~exif-js":"051f0f23"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"claim-accident-desc":1,"claim-detail":1,"claim-entry":1,"claim-goods-type":1,"claim-select-bank":1,"claim-select-order":1,"claim-select-responsible":1,"claim-status":1,"common-problem":1,"coupon-login":1,"coupon-qa":1,"login":1,"protection-rule":1,"reporting-center":1,"service-contract-rule":1,"accident~claim-supply~initiate-report~personal-accident":1,"accident~initiate-report":1,"accident":1,"initiate-report":1,"claim-supply":1,"personal-accident":1,"coupon-exchange":1,"coupon-invalid~coupon-list~coupon-select":1,"coupon-invalid":1,"new-coupon-select":1,"coupon-list":1,"coupon-select":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"claim-accident-desc":"claim-accident-desc","claim-detail":"claim-detail","claim-entry":"claim-entry","claim-goods-type":"claim-goods-type","claim-select-bank":"claim-select-bank","claim-select-order":"claim-select-order","claim-select-responsible":"claim-select-responsible","claim-status":"claim-status","common-problem":"common-problem","coupon-login":"coupon-login","coupon-qa":"coupon-qa","login":"login","protection-rule":"protection-rule","reporting-center":"reporting-center","service-contract-rule":"service-contract-rule","vendors~accident~claim-supply~initiate-report~personal-accident":"vendors~accident~claim-supply~initiate-report~personal-accident","accident~claim-supply~initiate-report~personal-accident":"accident~claim-supply~initiate-report~personal-accident","accident~initiate-report":"accident~initiate-report","accident":"accident","initiate-report":"initiate-report","claim-supply":"claim-supply","personal-accident":"personal-accident","vendors~coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"vendors~coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select","coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select","coupon-exchange":"coupon-exchange","coupon-invalid~coupon-list~coupon-select":"coupon-invalid~coupon-list~coupon-select","coupon-invalid":"coupon-invalid","new-coupon-select":"new-coupon-select","vendors~coupon-list":"vendors~coupon-list","coupon-list":"coupon-list","vendors~coupon-select":"vendors~coupon-select","coupon-select":"coupon-select","vendors~exif-js":"vendors~exif-js"}[chunkId]||chunkId) + "." + {"claim-accident-desc":"49ee6b50","claim-detail":"cc136ee9","claim-entry":"6ac154e4","claim-goods-type":"4781a2d4","claim-select-bank":"e71d23f6","claim-select-order":"bd60980e","claim-select-responsible":"35e2d91b","claim-status":"0a450a45","common-problem":"61ac84a6","coupon-login":"d6653f0c","coupon-qa":"5f72e6f7","login":"3eda592b","protection-rule":"020347ec","reporting-center":"4499a231","service-contract-rule":"5085fcef","vendors~accident~claim-supply~initiate-report~personal-accident":"31d6cfe0","accident~claim-supply~initiate-report~personal-accident":"457e316e","accident~initiate-report":"632cc32b","accident":"e71966bd","initiate-report":"58b26fd1","claim-supply":"41b8d5d3","personal-accident":"9300e4b7","vendors~coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"31d6cfe0","coupon-exchange~coupon-invalid~coupon-list~coupon-select~new-coupon-select":"31d6cfe0","coupon-exchange":"a7942b25","coupon-invalid~coupon-list~coupon-select":"f0010d8d","coupon-invalid":"83cdca12","new-coupon-select":"88820250","vendors~coupon-list":"31d6cfe0","coupon-list":"6808177b","vendors~coupon-select":"31d6cfe0","coupon-select":"638d0b3c","vendors~exif-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
 					linkTag.crossOrigin = "anonymous";
 				}
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "__VAN_STATIC_BASE_PATH__/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
